export default __webpack_public_path__ + "static/3-28-0-0-cb33b994157cdaed72e87eafed9313ce.jpg";